import { useEffect, useState } from "react";
import { ClipboardList, Pencil } from "lucide-react";

import { GROUP_TABS, GROUP_TABS_LIST, INTERACTION_TYPES } from "../consts";
import { callApi, getCourseLabel } from "../utils";
import MaterialsTab from "./materials-tab";
import OverviewTab from "./overview-tab";
import StatsTab from "./stats-tab";

export default function GroupDetails({
  allTeachers,
  getGroups,
  selectedGroup,
  tab,
  setTab,
}) {
  const [practicals, setPracticals] = useState([]);
  const [editOpen, setEditOpen] = useState(false);

  const getPracticals = () => {
    const groupId = selectedGroup?.id;
    if (groupId) {
      callApi({
        method: "GET",
        path: `api/teacher/practice-groups/${groupId}/practicals`,
        needAuth: true,
      }).then((response) => {
        const err = response.error;
        if (err) {
          console.error(err);
        } else {
          const respArr = response.response;
          if (respArr) {
            setPracticals(respArr);
          } else {
            console.error(respArr);
          }
        }
      });
    }
  };

  useEffect(getPracticals, [selectedGroup?.id]);

  const renderTabContent = () => {
    switch (tab) {
      case GROUP_TABS.overview:
        return (
          <OverviewTab
            group={selectedGroup}
            getGroups={getGroups}
            practicals={practicals}
            getPracticals={getPracticals}
            allTeachers={allTeachers}
            editOpen={editOpen}
            closeModal={() => setEditOpen(false)}
          />
        );
      case GROUP_TABS.materials:
        return (
          <MaterialsTab
            group={selectedGroup}
            practicals={practicals}
            getPracticals={getPracticals}
          />
        );
      case GROUP_TABS.stats:
        return <StatsTab getGroups={getGroups} group={selectedGroup} />;
    }
  };

  const renderContent = () => {
    if (!selectedGroup) {
      return (
        <div className="empty-state">
          <ClipboardList size={28} />
          <h3>Пока нет ни одной группы</h3>
          <p>
            Добавьте группу студентов, чтобы настроить практические работы и
            материалы.
          </p>
        </div>
      );
    }

    return (
      <>
        <div className="content-head">
          <div>
            <h2>{selectedGroup.group}</h2>
            <p className="muted">
              {getCourseLabel(selectedGroup.course)} ·{" "}
              {selectedGroup.interactionType === INTERACTION_TYPES.individual
                ? "Индивидуальный формат"
                : `Групповой формат, ${selectedGroup.subgroupsCount} подгр.`}
            </p>
          </div>
          <div className="tabs">
            {selectedGroup.owner && tab === GROUP_TABS.overview && (
              <button className="btn small" onClick={() => setEditOpen(true)}>
                <Pencil size={14} /> Редактировать
              </button>
            )}
            {GROUP_TABS_LIST.map(({ key, label }) => (
              <button
                key={key}
                className={"tab" + (tab === key ? " active" : "")}
                onClick={() => setTab(key)}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
        {renderTabContent()}
      </>
    );
  };

  return <section className="content">{renderContent()}</section>;
}
